module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Reid_Wisdoms_Feast3#toc2"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ant.")]), _vm._v("\tJosephus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish Antiquities")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BAR")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblical Archaeology Review")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("BDAG\t"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Greek-­English Lexicon of the New Testament and Other Early Christian Literature. ")]), _vm._v("3d ed. Revised and edited by Frederick William Danker. Chicago: University of Chicago Press, 2000")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("BJS\tBrown Judaic Studies")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BTB")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblical Theology Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("CCEL\tChristian Classics Ethereal Library")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("CNT\tCompanions to the New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DRev")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Downside Review")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("FCNT\tFeminist Companion to the New Testament and Early Christian Writings")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("GNS\tGood News Studies")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("ICC\tInternational Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("IFT\tIntroductions in Feminist Theology")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Int")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("J.W.")]), _vm._v("\tJosephus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish War")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("KJV\tKing James Version")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NAB\tNew American Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NASB\tNew American Standard Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NEB\tNew English Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NJB\tNew Jerusalem Bible")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("NRSV\tNew Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NTR")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Theology Review")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("OBT\tOvertures to Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("OECS\tOxford Early Christian Studies")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("PG\tMigne, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Patrologia Graeca")])]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("PTMS\tPrinceton Theological Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("SBLSymS\tSociety of Biblical Literature Symposium Series")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_vm._v("SVC\tSupplements to Vigiliae Christianae")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7efcab64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reid_Wisdoms_Feast-5.vue
// module id = 69
// module chunks = 0